<template>
	<span v-bind:class="['rds-spinner', colorClass, sizeClass]" v-text="txtLoading"></span>
</template>

<script>
export default {
	props: ['color', 'size'],
	computed: {
		colorClass() {
			return (this.color) ? 'rds-spinner--' + this.color : ''
		},
		sizeClass() {
			return (this.size) ? 'rds-spinner--' + this.size : ''
		},
		txtLoading() {
			return this.$t('loading') || ''
		}
	}
}
</script>

<style scoped lang="scss">
	@import '~@ruter/rds-scss-core/src/scss/03-base/animations';
	@import '~@ruter/rds-components/src/Spinner/Spinner';
</style>
